/**
 * Enables automatic iframe height resizing when this widget is embedded
 * in a parent page using @open-iframe-resizer/react or @open-iframe-resizer/core.
 *
 * Importing the core package registers a child listener that responds to the
 * parent's resize handshake. No explicit call is required.
 */
import "@open-iframe-resizer/core";

/** Selector for the element whose dimensions should be reported to the parent. */
export const IFRAME_RESIZE_TARGET_SELECTOR = "#ripcityrewards-app";

export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
